import gql from 'graphql-tag';

export const GET_STOCK_ORDERS = gql`
  query getStockOrders(
    $locationId: ID
    $search: String
    $pagination: PaginationAttributes
    $status: String
  ) {
    items: stockOrders(
      locationId: $locationId
      search: $search
      pagination: $pagination
      status: $status
    ) {
      id
      cid
      createdAt
      quantity
      status
      supplier {
        id
        name
      }
    }
  }
`;

export const DELETE_STOCK_ORDER = gql`
  mutation deleteStockOrder($input: DeleteStockOrderInput!) {
    deleteStockOrder(input: $input) {
      stockOrder {
        id
      }
    }
  }
`;
